module.exports = __webpack_public_path__ + "img/7-424-424.77558bd7.png";